import {
  isActiveExact,
  MenuGroup,
  removeHiddenItems,
} from 'structure/Layouts/LayoutWithSideBar/menu';

export const buildMenuDappDesktop = (
  t: (name: string) => string
): MenuGroup[] => {
  const menu: MenuGroup[] = [
    {
      label: '',
      items: [
        {
          label: 'Capital Manager',
          icon: 'dashboards',
          href: '/capital_manager',
        },
      ],
    },
    {
      label: 'Earn',
      items: [
        {
          label: 'Vaults',
          icon: 'vault',
          href: '/vaults',
        },
        {
          label: 'Staking',
          icon: 'coins',
          href: '/staking',
        },
      ],
    },
    {
      label: 'Tools',
      items: [
        {
          label: 'Bridge',
          icon: 'bridge',
          href: '/bridge',
        },
        {
          label: 'Migrate',
          icon: 'migrate',
          href: '/migrate',
          isActive: isActiveExact,
        },
        {
          label: 'Claim testnet rewards',
          icon: 'smart_toy',
          href: '/testnet/claim',
          isActive: isActiveExact,
        },
      ],
    },
    {
      label: 'Settings',
      items: [
        {
          label: 'Docs',
          icon: 'document',
          href: 'https://singularityfinance.ai/docs/',
          target: '_blank',
        },
      ],
    },
  ];

  return menu.reduce(removeHiddenItems, []) as MenuGroup[];
};
